isMobile();
function isMobile() {
  let flag =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
    if(flag){
      window.location.href="https://sgm.hiso33as.org"
    }else{
      console.log('pc端');
      console.log(window.location);
      
    }

}